import { StoreConfig, Store } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { IdName } from '@app-services/oem-dealer.service';
import { FederatedLoginConfig, FooterLink, Script, ValueConfig } from '@app/views/private/admin/model/advertisers';
import { FipeComparisonMode } from '@app-utils/fipe-comparison.utils';

export interface OemDealers {
  id: string;
  name: string;
  inactive: boolean;
  allowLeadGeneration: boolean;
}

export enum Role {
  REGISTERER = 'REGISTERER',
  USER = 'USER',

  ADMIN = 'ADMIN',

  // arremate
  DEALER = 'DEALER',
  DESK_SELL = 'DESK_SELL',
  OEM_DEALER_MANAGER = 'OEM_DEALER_MANAGER',
  LOCATION_MANAGER = "LOCATION_MANAGER",

  // avaliar
  EVALUATOR = 'EVALUATOR',
  SELLER = 'SELLER',
  DESK_BUY = 'DESK_BUY',
  SELLER_MANAGER = 'SELLER_MANAGER',
  EVAL_DEALER_MANAGER = 'EVAL_DEALER_MANAGER',
  SUPER_EVALUATOR = "SUPER_EVALUATOR"
}

export enum Permission {
  ABANDON_PRICING = 'ABANDON_PRICING',
  CREATE_EVALUATION = 'CREATE_EVALUATION',
  EDIT_EVALUATION = 'EDIT_EVALUATION',
  EDIT_EVALATION_IN_PRICING = 'EDIT_EVALATION_IN_PRICING',
  CHANGE_EVAL_DEALER = 'CHANGE_EVAL_DEALER',
  CHANGE_APPLICANT = 'CHANGE_APPLICANT',
  EVALUATE_EVALUATION = 'EVALUATE_EVALUATION',
  PRICE_EVALUATION = 'PRICE_EVALUATION',
  VIEW_EVALUATION_DETAILS = 'VIEW_EVALUATION_DETAILS',
  VIEW_EVALUATION_WITHOUT_ASSUMING_PRICING = 'VIEW_EVALUATION_WITHOUT_ASSUMING_PRICING',
  VIEW_ASSIGNED_EVALUATIONS_EVALUATOR = 'VIEW_ASSIGNED_EVALUATIONS_EVALUATOR',
  VIEW_ALL_EVALUATIONS_EVALUATOR = 'VIEW_ALL_EVALUATIONS_EVALUATOR',
  VIEW_ASSIGNED_PRICING_EVALUATIONS = 'VIEW_ASSIGNED_PRICING_EVALUATIONS',
  VIEW_ALL_PRICING_EVALUATIONS = 'VIEW_ALL_PRICING_EVALUATIONS',
  VIEW_EXPIRED_MY_EVALUATIONS = 'VIEW_EXPIRED_MY_EVALUATIONS',
  VIEW_EXPIRED_EVALUATIONS = 'VIEW_EXPIRED_EVALUATIONS',
  VIEW_CANCELLED_MY_EVALUATIONS = 'VIEW_CANCELLED_MY_EVALUATIONS',
  VIEW_CANCELLED_EVALUATIONS = 'VIEW_CANCELLED_EVALUATIONS',
  VIEW_PURCHASED_MY_EVALUATIONS = 'VIEW_PURCHASED_MY_EVALUATIONS',
  VIEW_PURCHASED_EVALUATIONS = 'VIEW_PURCHASED_EVALUATIONS',
  VIEW_PRICING_PRICE = 'VIEW_PRICING_PRICE',
  VIEW_PRICING_COMMENTS = 'VIEW_PRICING_COMMENTS',
  RETURN_TO_EVALUATOR = 'RETURN_TO_EVALUATOR',
  RETURN_TO_PRICING = 'RETURN_TO_PRICING',
  CANCEL_EVALUATION = 'CANCEL_EVALUATION',
  CONFIRM_EVALUATION_PURCHASE = 'CONFIRM_EVALUATION_PURCHASE',
  SEND_TO_FAST_QUOTE = 'SEND_TO_FAST_QUOTE',
  BUY_VEHICLE_HISTORY = 'BUY_VEHICLE_HISTORY',
  IMPORT_MASS_EVALUATIONS = 'IMPORT_MASS_EVALUATIONS',
  EDIT_EVALUATION_PRICE = 'EDIT_EVALUATION_PRICE',
  EDIT_EVALUATION_SCORE = 'EDIT_EVALUATION_SCORE',
  VIEW_EVALUATION_STATUS_FILTERS = 'VIEW_EVALUATION_STATUS_FILTERS',
  VIEW_CAST_OFF_VEHICLES_SUMMARY = 'VIEW_CAST_OFF_VEHICLES_SUMMARY',
  ARCHIVE_EVALUATION = 'ARCHIVE_EVALUATION',
  UNARCHIVE_EVALUATION = 'UNARCHIVE_EVALUATION',
  REACTIVATE_EVALUATION = 'REACTIVATE_EVALUATION',
  VIEW_ALL_FAST_QUOTE_PROPOSALS = 'VIEW_ALL_FAST_QUOTE_PROPOSALS',
  VIEW_HIGHEST_FAST_QUOTE_PROPOSAL = 'VIEW_HIGHEST_FAST_QUOTE_PROPOSAL',
  ACCEPT_HIGHEST_FAST_QUOTE_PROPOSAL = 'ACCEPT_HIGHEST_FAST_QUOTE_PROPOSAL',
  ACCEPT_ANY_FAST_QUOTE_PROPOSAL = 'ACCEPT_ANY_FAST_QUOTE_PROPOSAL',
  VIEW_EVALUATION_HISTORY = 'VIEW_EVALUATION_HISTORY',
  DOWNLOAD_RAIOX_AAR = 'DOWNLOAD_RAIOX_AAR',
  PROVIDE_LINK_RAIOX_ONLINE = 'PROVIDE_LINK_RAIOX_ONLINE',
  PROVIDE_LINK_PLUGIN_RAIOX = 'PROVIDE_LINK_PLUGIN_RAIOX',
  VIEW_EVALUATION_DASHBOARD = 'VIEW_EVALUATION_DASHBOARD',
  DOWNLOAD_EVALUATION_REPORTS = 'DOWNLOAD_EVALUATION_REPORTS',
  VIEW_MIN_PRICE_AND_LIST_PRICE = "VIEW_MIN_PRICE_AND_LIST_PRICE",
  VIEW_EVALUATION_EVOLUTION = "VIEW_EVALUATION_EVOLUTION",
  VIEW_EVALUATION_PRICE_HISTORY = 'VIEW_EVALUATION_PRICE_HISTORY',
  CHANGE_NEGOTIATION_STATUS = "CHANGE_NEGOTIATION_STATUS",
  SEND_TO_TRANSFER = "SEND_TO_TRANSFER",
  VIEW_STOCK = "VIEW_STOCK",
  VIEW_TRANSFER_VEHICLES = "VIEW_TRANSFER_VEHICLES",
  IMPORT_MASS_TRANSFERS = "IMPORT_MASS_TRANSFERS",
  VIEW_DELETED_VEHICLES = "VIEW_DELETED_VEHICLES",
  VIEW_LEADS_VEHICLES = "VIEW_LEADS_VEHICLES",
  VIEW_REPORT_SELL = "VIEW_REPORT_SELL",
  VIEW_TRADEIN_DASHBOARD = "VIEW_TRADEIN_DASHBOARD",
  ADD_VEHICLE_MANUALLY = "ADD_VEHICLE_MANUALLY",
  ADD_VEHICLE_FROM_NUMBER_PLATE_LIST = "ADD_VEHICLE_FROM_NUMBER_PLATE_LIST",
  ADD_VEHICLE_FROM_PDF_IMPORT = "ADD_VEHICLE_FROM_PDF_IMPORT",
  DOWNLOAD_TRANSFER_VEHICLE_CSV = "DOWNLOAD_TRANSFER_VEHICLE_CSV",
  DOWNLOAD_AUCTION_REPORT_CSV = "DOWNLOAD_AUCTION_REPORT_CSV",
  DOWNLOAD_DASHBOARD_TRANSFER_CSV = "DOWNLOAD_DASHBOARD_TRANSFER_CSV",
  DOWNLOAD_DASHBOARD_DEALER_CSV = "DOWNLOAD_DASHBOARD_DEALER_CSV",
  DOWNLOAD_DASHBOARD_TRANSFER_PDF = "DOWNLOAD_DASHBOARD_TRANSFER_PDF",
  PUBLISH_VEHICLE = "PUBLISH_VEHICLE",
  CANCEL_VEHICLE = "CANCEL_VEHICLE",
  RESTORE_VEHICLE = "RESTORE_VEHICLE",
  SET_MANUALLY_FINISH_TIME = "SET_MANUALLY_FINISH_TIME",
  DIRECT_SALE_VEHICLE = "DIRECT_SALE_VEHICLE",
  DIRECT_SALE_TO_CONDITIONAL = "DIRECT_SALE_TO_CONDITIONAL",
  ADD_EVALUATION_PRIVATE_COMMENT = "ADD_EVALUATION_PRIVATE_COMMENT",
  ADD_EVALUATION_COMMENT = "ADD_EVALUATION_COMMENT",
  EDIT_EVALUATION_PRIVATE_COMMENT = "EDIT_EVALUATION_PRIVATE_COMMENT",
  EDIT_EVALUATION_COMMENT = "EDIT_EVALUATION_COMMENT",
  VIEW_EVALUATION_PRIVATE_COMMENTS = "VIEW_EVALUATION_PRIVATE_COMMENTS",
  VIEW_EVALUATION_COMMENTS = "VIEW_EVALUATION_COMMENTS",
  RESYNC_EVALUATION_INTEGRATION = "RESYNC_EVALUATION_INTEGRATION",
  VIEW_INTEGRATION_HISTORY_DETAILS = 'VIEW_INTEGRATION_HISTORY_DETAILS',
  VIEW_AWAITING_ENTRY_EVALUATIONS = "VIEW_AWAITING_ENTRY_EVALUATIONS",
  CHANGE_VEHICLE_DESTINATION = "CHANGE_VEHICLE_DESTINATION",
  DUPLICATE_EVALUATION = "DUPLICATE_EVALUATION",
  VIEW_ARCHIVED_EVALUATIONS = 'VIEW_ARCHIVED_EVALUATIONS',
  RETURN_TO_NEGOTIATION = 'RETURN_TO_NEGOTIATION',
  CANCEL_SALE = "CANCEL_SALE",
  DASHBOARD_MAIN_PAGE = "DASHBOARD_MAIN_PAGE",
  VIEW_POTENTIAL_BUYERS = 'VIEW_POTENTIAL_BUYERS',
  VIEW_WEBHOOK_HISTORY = 'VIEW_WEBHOOK_HISTORY',
  ACCEPT_PROPOSAL_BELOW_MARGIN = 'ACCEPT_PROPOSAL_BELOW_MARGIN',
  VIEW_ALL_LOCATION_VEHICLES = 'VIEW_ALL_LOCATION_VEHICLES',
  FINISH_PUBLICATION_WITH_PROPOSAL = 'FINISH_PUBLICATION_WITH_PROPOSAL',
  DOWNLOAD_DEALERS_EVENTS_CSV = 'DOWNLOAD_DEALERS_EVENTS_CSV',
  VIEW_RESCUES = 'VIEW_RESCUES',
  ASSUME_RESCUE = 'ASSUME_RESCUE',
  RELEASE_RESCUE = 'RELEASE_RESCUE',
  ASSIGN_RESCUE = 'ASSIGN_RESCUE',
  DOWNLOAD_RESCUE_CSV = 'DOWNLOAD_RESCUE_CSV',
  VIEW_TRANSFER_VIEWERS = 'VIEW_TRANSFER_VIEWERS',
  VIEW_FAST_QUOTE_VIEWERS = 'VIEW_FAST_QUOTE_VIEWERS',
  // OEM_DEALER_ADMIN

  MANAGE_EMPLOYEES = 'MANAGE_EMPLOYEES',
  MANAGE_EVAL_DEALERS = 'MANAGE_EVAL_DEALERS',
  MANAGE_OEM_DEALER_LOCATION = 'MANAGE_OEM_DEALER_LOCATION',
  MANAGER_PERSONALIZATION = 'MANAGER_PERSONALIZATION',
  MANAGE_ACCESS_PROFILES = 'MANAGE_ACCESS_PROFILES',
  ACTIVATE_DEACTIVATE_ENVIRONMENT = 'ACTIVATE_DEACTIVATE_ENVIRONMENT',
  EDIT_ENVIRONMENT_INFO = 'EDIT_ENVIRONMENT_INFO',
  MANAGE_ENVIRONMENT_USERS = 'MANAGE_ENVIRONMENT_USERS',
  IMPORT_MASS_USERS = 'IMPORT_MASS_USERS',
  MANAGE_SELLER_PERSONALIZATION = 'MANAGE_SELLER_PERSONALIZATION',
  MANAGE_EVALUATION_RULES = 'MANAGE_EVALUATION_RULES',
  MANAGE_EXCLUSIVE_GROUPS = 'MANAGE_EXCLUSIVE_GROUPS',
  MANAGE_BLOCKED_BUYERS = 'MANAGE_BLOCKED_BUYERS',
  MANAGE_FAST_QUOTE_PRIORITY_STORES = 'MANAGE_FAST_QUOTE_PRIORITY_STORES',
  MANAGE_RAIOX_PLUGIN = 'MANAGE_RAIOX_PLUGIN',
  MANAGE_RAIOX_PDF = 'MANAGE_RAIOX_PDF',
  GENERATE_PAYMENT_METHOD = 'GENERATE_PAYMENT_METHOD',
  MANAGE_PRICING_CALCULATOR = 'MANAGE_PRICING_CALCULATOR',
  VIEW_TRADE_IN_PRICING_CALCULATOR = 'VIEW_TRADE_IN_PRICING_CALCULATOR',
  MANAGE_TRADE_IN_AUTO_PRICING = 'MANAGE_TRADE_IN_AUTO_PRICING',
  MANAGE_RESCUE_CONFIG = 'MANAGE_RESCUE_CONFIG',
  MANAGE_AUCTION_CANCELLATION_REQUESTS = 'MANAGE_AUCTION_CANCELLATION_REQUESTS',
  // SYSTEM_ADMIN (Plataforma)
  GLOBAL_ACCESS = 'GLOBAL_ACCESS',
  CREATE_NEW_OEMDEALER = 'CREATE_NEW_OEMDEALER',
  VIEW_DEALERS = 'VIEW_DEALERS',
  DOWNLOAD_DEALER_CSV = 'DOWNLOAD_DEALER_CSV',
  VIEW_OEMDEALERS = 'VIEW_OEMDEALERS',
  DOWNLOAD_OEMDEALER_CSV = 'DOWNLOAD_OEMDEALER_CSV',
  VIEW_BANKSLIPS = 'VIEW_BANKSLIPS',
  VIEW_BANKSLIPS_SUMMARY = 'VIEW_BANKSLIPS_SUMMARY',
  MANAGE_AUCTION_REFUNDS = 'MANAGE_AUCTION_REFUNDS',
  GENERATE_AUCTION_CANCELLATION_LINK = 'GENERATE_AUCTION_CANCELLATION_LINK',
  VIEW_INTEGRATIONS = 'VIEW_INTEGRATIONS',
  MANAGE_SELLER_INTEGRATIONS = 'MANAGE_SELLER_INTEGRATIONS',
  MANAGE_SELLER_CONTRACTS = 'MANAGE_SELLER_CONTRACTS',
  MANAGE_BANNERS = 'MANAGE_BANNERS',
  MANAGE_HOME = 'MANAGE_HOME',
  MANAGE_SLUG = 'MANAGE_SLUG',
  MANAGE_FIPE = 'MANAGE_FIPE',
  MANAGE_REGIONALS = 'MANAGE_REGIONALS',
  MANAGE_API_KEYS = 'MANAGE_API_KEYS',
  DOWNLOAD_BANKSLIP_CSV = 'DOWNLOAD_BANKSLIP_CSV',
  RESSUE_BANKSLIP = 'RESSUE_BANKSLIP',
  OVERRIDE_TRADE_IN_PRICING_CALCULATOR_PRICE = 'OVERRIDE_TRADE_IN_PRICING_CALCULATOR_PRICE',
  MANAGE_DEALER_PROSPECTS = 'MANAGE_DEALER_PROSPECTS',
}

export const OEM_DEALER_ADMIN_PERMISSIONS = [
  Permission.MANAGE_EVAL_DEALERS,
  Permission.MANAGE_OEM_DEALER_LOCATION,
  Permission.MANAGER_PERSONALIZATION,
  Permission.MANAGE_ENVIRONMENT_USERS,
  Permission.IMPORT_MASS_USERS,
  Permission.MANAGE_SELLER_PERSONALIZATION,
  Permission.MANAGE_EVALUATION_RULES,
  Permission.MANAGE_EXCLUSIVE_GROUPS,
  Permission.MANAGE_BLOCKED_BUYERS,
  Permission.MANAGE_FAST_QUOTE_PRIORITY_STORES,
  Permission.MANAGE_RAIOX_PLUGIN,
  Permission.MANAGE_RAIOX_PDF,
  Permission.MANAGE_PRICING_CALCULATOR,
  Permission.MANAGE_TRADE_IN_AUTO_PRICING,
  Permission.MANAGE_RESCUE_CONFIG,
  Permission.MANAGE_ACCESS_PROFILES,
  Permission.MANAGE_AUCTION_CANCELLATION_REQUESTS,
] as const;

export const SYSTEM_ADMIN_PERMISSIONS = [
  Permission.GLOBAL_ACCESS,
  Permission.CREATE_NEW_OEMDEALER,
  Permission.VIEW_DEALERS,
  Permission.DOWNLOAD_DEALER_CSV,
  Permission.VIEW_OEMDEALERS,
  Permission.DOWNLOAD_OEMDEALER_CSV,
  Permission.VIEW_BANKSLIPS,
  Permission.VIEW_BANKSLIPS_SUMMARY,
  Permission.MANAGE_AUCTION_REFUNDS,
  Permission.GENERATE_AUCTION_CANCELLATION_LINK,
  Permission.VIEW_INTEGRATIONS,
  Permission.MANAGE_SELLER_INTEGRATIONS,
  Permission.MANAGE_SELLER_CONTRACTS,
  Permission.MANAGE_BANNERS,
  Permission.MANAGE_HOME,
  Permission.MANAGE_SLUG,
  Permission.MANAGE_FIPE,
  Permission.MANAGE_REGIONALS,
  Permission.MANAGE_API_KEYS,
  Permission.DOWNLOAD_BANKSLIP_CSV,
  Permission.RESSUE_BANKSLIP,
  Permission.MANAGE_DEALER_PROSPECTS,
] as const;

export const LEGACY_ADMIN_ROLES = [Role.ADMIN] as const;

export const LEGACY_SELL_ROUTE_ROLES = [
  Role.ADMIN,
  Role.DEALER,
  Role.OEM_DEALER_MANAGER,
  Role.DESK_SELL,
  Role.REGISTERER,
  Role.LOCATION_MANAGER,
] as const;

export const LEGACY_BUY_ROUTE_ROLES = [
  Role.SELLER,
  Role.SELLER_MANAGER,
  Role.EVALUATOR,
  Role.ADMIN,
  Role.DESK_BUY,
  Role.OEM_DEALER_MANAGER,
  Role.EVAL_DEALER_MANAGER,
  Role.SUPER_EVALUATOR,
] as const;

export const LEGACY_EVAL_DASHBOARD_ROLES = [
  Role.ADMIN,
  Role.OEM_DEALER_MANAGER,
  Role.DESK_BUY,
  Role.SELLER_MANAGER,
  Role.SELLER,
  Role.EVAL_DEALER_MANAGER,
] as const;

export const LEGACY_TRADEIN_DASHBOARD_ROLES = [
  Role.ADMIN,
  Role.OEM_DEALER_MANAGER,
  Role.DESK_SELL,
  Role.LOCATION_MANAGER,
] as const;

export const LEGACY_TRANSFER_ROUTE_ROLES = [
  Role.ADMIN,
  Role.DESK_SELL,
  Role.OEM_DEALER_MANAGER,
  Role.REGISTERER,
  Role.LOCATION_MANAGER,
] as const;

export const LEGACY_OEM_DEALER_CONTEXT_ROLES = [
  Role.ADMIN,
  Role.OEM_DEALER_MANAGER,
  Role.DESK_BUY,
  Role.DESK_SELL,
  Role.LOCATION_MANAGER,
] as const;

export const LEGACY_EVAL_LEADS_ROLES = [
  Role.SELLER_MANAGER,
  Role.ADMIN,
  Role.OEM_DEALER_MANAGER,
  Role.DESK_BUY,
  Role.SELLER,
  Role.EVAL_DEALER_MANAGER,
] as const;

export const LEGACY_EVAL_HISTORY_ROLES = [
  Role.SELLER_MANAGER,
  Role.ADMIN,
  Role.OEM_DEALER_MANAGER,
  Role.DESK_BUY,
  Role.EVAL_DEALER_MANAGER,
  Role.SUPER_EVALUATOR,
  Role.SELLER,
] as const;

export const BUY_PERMISSIONS = [
  Permission.ABANDON_PRICING,
  Permission.CREATE_EVALUATION,
  Permission.EDIT_EVALUATION,
  Permission.EDIT_EVALATION_IN_PRICING,
  Permission.CHANGE_APPLICANT,
  Permission.EVALUATE_EVALUATION,
  Permission.PRICE_EVALUATION,
  Permission.VIEW_EVALUATION_DETAILS,
  Permission.VIEW_ASSIGNED_EVALUATIONS_EVALUATOR,
  Permission.VIEW_ALL_EVALUATIONS_EVALUATOR,
  Permission.VIEW_ASSIGNED_PRICING_EVALUATIONS,
  Permission.VIEW_ALL_PRICING_EVALUATIONS,
  Permission.VIEW_EXPIRED_MY_EVALUATIONS,
  Permission.VIEW_EXPIRED_EVALUATIONS,
  Permission.VIEW_CANCELLED_MY_EVALUATIONS,
  Permission.VIEW_CANCELLED_EVALUATIONS,
  Permission.VIEW_PURCHASED_MY_EVALUATIONS,
  Permission.VIEW_PURCHASED_EVALUATIONS,
  Permission.VIEW_PRICING_PRICE,
  Permission.VIEW_PRICING_COMMENTS,
  Permission.RETURN_TO_EVALUATOR,
  Permission.RETURN_TO_PRICING,
  Permission.CANCEL_EVALUATION,
  Permission.CONFIRM_EVALUATION_PURCHASE,
  Permission.SEND_TO_FAST_QUOTE,
  Permission.BUY_VEHICLE_HISTORY,
  Permission.IMPORT_MASS_EVALUATIONS,
  Permission.EDIT_EVALUATION_PRICE,
  Permission.EDIT_EVALUATION_SCORE,
  Permission.VIEW_EVALUATION_STATUS_FILTERS,
  Permission.ARCHIVE_EVALUATION,
  Permission.UNARCHIVE_EVALUATION,
  Permission.REACTIVATE_EVALUATION,
  Permission.VIEW_ALL_FAST_QUOTE_PROPOSALS,
  Permission.VIEW_HIGHEST_FAST_QUOTE_PROPOSAL,
  Permission.ACCEPT_HIGHEST_FAST_QUOTE_PROPOSAL,
  Permission.ACCEPT_ANY_FAST_QUOTE_PROPOSAL,
  Permission.VIEW_EVALUATION_HISTORY,
  Permission.DOWNLOAD_RAIOX_AAR,
  Permission.PROVIDE_LINK_RAIOX_ONLINE,
  Permission.PROVIDE_LINK_PLUGIN_RAIOX,
  Permission.VIEW_EVALUATION_DASHBOARD,
  Permission.DOWNLOAD_EVALUATION_REPORTS,
  Permission.VIEW_MIN_PRICE_AND_LIST_PRICE,
  Permission.VIEW_EVALUATION_EVOLUTION,
  Permission.VIEW_EVALUATION_PRICE_HISTORY,
  Permission.CHANGE_NEGOTIATION_STATUS,
  Permission.SEND_TO_TRANSFER,
  Permission.ADD_EVALUATION_PRIVATE_COMMENT,
  Permission.ADD_EVALUATION_COMMENT,
  Permission.EDIT_EVALUATION_PRIVATE_COMMENT,
  Permission.EDIT_EVALUATION_COMMENT,
  Permission.VIEW_EVALUATION_PRIVATE_COMMENTS,
  Permission.VIEW_EVALUATION_COMMENTS,
  Permission.RESYNC_EVALUATION_INTEGRATION,
  Permission.VIEW_AWAITING_ENTRY_EVALUATIONS,
  Permission.CHANGE_VEHICLE_DESTINATION,
  Permission.RETURN_TO_NEGOTIATION,
  Permission.DUPLICATE_EVALUATION,
  Permission.VIEW_ARCHIVED_EVALUATIONS,
  Permission.DASHBOARD_MAIN_PAGE,
  Permission.VIEW_RESCUES,
  Permission.ASSUME_RESCUE,
  Permission.RELEASE_RESCUE,
  Permission.ASSIGN_RESCUE,
  Permission.DOWNLOAD_RESCUE_CSV,
  Permission.OVERRIDE_TRADE_IN_PRICING_CALCULATOR_PRICE
] as const;

export const EVAL_RESCUE_VIEW_PERMISSIONS = [Permission.VIEW_RESCUES] as const;

export const LEGACY_EVAL_RESCUE_ROLES = [
  Role.ADMIN,
  Role.OEM_DEALER_MANAGER,
] as const;

export const EVAL_LEADS_PERMISSIONS = [
  Permission.PROVIDE_LINK_PLUGIN_RAIOX,
  Permission.PROVIDE_LINK_RAIOX_ONLINE,
  Permission.MANAGE_RAIOX_PLUGIN,
] as const;

export const SELL_PERMISSIONS = [
  Permission.VIEW_STOCK,
  Permission.VIEW_TRANSFER_VEHICLES,
  Permission.IMPORT_MASS_TRANSFERS,
  Permission.VIEW_DELETED_VEHICLES,
  Permission.VIEW_LEADS_VEHICLES,
  Permission.VIEW_REPORT_SELL,
  Permission.VIEW_TRADEIN_DASHBOARD,
  Permission.VIEW_CAST_OFF_VEHICLES_SUMMARY,
  Permission.ADD_VEHICLE_MANUALLY,
  Permission.ADD_VEHICLE_FROM_NUMBER_PLATE_LIST,
  Permission.ADD_VEHICLE_FROM_PDF_IMPORT,
  Permission.DOWNLOAD_TRANSFER_VEHICLE_CSV,
  Permission.DOWNLOAD_AUCTION_REPORT_CSV,
  Permission.DOWNLOAD_DASHBOARD_TRANSFER_CSV,
  Permission.DOWNLOAD_DASHBOARD_DEALER_CSV,
  Permission.DOWNLOAD_DASHBOARD_TRANSFER_PDF,
  Permission.PUBLISH_VEHICLE,
  Permission.CANCEL_VEHICLE,
  Permission.RESTORE_VEHICLE,
  Permission.SET_MANUALLY_FINISH_TIME,
  Permission.DIRECT_SALE_VEHICLE,
  Permission.DIRECT_SALE_TO_CONDITIONAL,
  Permission.CANCEL_SALE,
  Permission.VIEW_POTENTIAL_BUYERS,
  Permission.VIEW_WEBHOOK_HISTORY,
  Permission.ACCEPT_PROPOSAL_BELOW_MARGIN,
  Permission.VIEW_ALL_LOCATION_VEHICLES,
  Permission.FINISH_PUBLICATION_WITH_PROPOSAL,
  Permission.DOWNLOAD_DEALERS_EVENTS_CSV,
  Permission.VIEW_TRANSFER_VIEWERS,
  Permission.VIEW_FAST_QUOTE_VIEWERS,
] as const;

const PLATFORM_DASHBOARD_PERMISSIONS = new Set<Permission>([
  Permission.VIEW_EVALUATION_DASHBOARD,
  Permission.DASHBOARD_MAIN_PAGE,
  Permission.VIEW_LEADS_VEHICLES,
  Permission.VIEW_TRADEIN_DASHBOARD,
]);

export interface AccessProfile {
  id: string;
  oemDealerId: string;
  name: string;
  description?: string;
  permissions: Permission[];
  systemProfile: boolean;
  inactive: boolean;
}
export class UserInfo {
  automaticImportTermsAccepted: boolean;
  id: string;
  name: string;
  email: string;
  hasPlan: boolean;
  hasTradeInPricingConfig: boolean;
  firstName: string;
  dealerName: string;
  dealerId: string;
  dealerType: string;
  dealerHasCNAE4511: boolean;
  dealerFloorPlanEnabled: boolean;
  dealerGroupSelected: IdName;
  dealers: IdName[];
  dealerGroupName: string;
  isPrivateDealer: boolean;
  privateAuthorizedByOemDealerIds: string[];
  showAuctionLeads: boolean;
  oemDealerName: string;
  oemDealerGroupName: string;
  oemDealerGroupSelected: OemDealers;
  oemDealersWithIntegrationReport: string[];
  oemDealers: OemDealers[];
  oemDealerId: string;
  evalDealerId?: string;
  evalDealerName?: string;
  evalDealers: IdName[]
  virtualEvalDealer?: boolean;
  roles: Role[];
  hasLatePayment: boolean;
  city: string;
  uf: string;
  region: string;
  target?: string;
  useEvalScoreABC?: boolean;
  requiredExtraKeyAndCarManual?: boolean;
  requiredPricingFields?: boolean;
  showEvalDashboardCreated?: boolean;
  showEvalDashboardPerformed?: boolean;
  status?: string;
  locationsIds: string[]
  requiredReport: boolean;
  blockToBuy: boolean;
  requiredInfoOwner: boolean;
  allowSellerToEvaluate: boolean;
  blockSellerSeeOffers: boolean;
  automaticImportTermsAcceptedAt: Date;
  shouldShowModal: boolean;
  shouldShowMigrationModal: boolean;
  shouldShowTermsModal: boolean;
  isMigrationMandatory: boolean;
  migrationMandatoryDate: Date;
  shouldShowSuperBidPendingModal: boolean;
  superBidPendingType: string;
  superBidRedirectUrl: string;
  requiredEvalOwnerConfirmation: boolean;
  enableChassisEval?: boolean;
  evalTypes?: string[];
  fipeComparisonMode?: FipeComparisonMode;
  accessProfile?: AccessProfile;
  showCheckoutMigrationNotification: boolean;
  purchaseProfileOnboarding?: {
    status: 'PENDING' | 'COMPLETED';
    shouldShowModal: boolean;
    nextShowAt?: string;
    lastSavedAt?: string;
    lastSkippedAt?: string;
  };
  segmentComissionConfigs?: Map<string, ValueConfig>;

  hasRole(role: string): boolean {
    if (!this.roles?.length) {
      return false;
    }
    for (const r of this.roles) {
      if (r === role) {
        return true;
      }
    }
    return false;
  }

  hasRoles(...roles: string[]) {
    for (const role of roles) {
      if (this.hasRole(role)) {
        return true;
      }
    }
    return false;
  }

  hasPermission(permission: Permission): boolean {
    if (this.isPlatformAdmin()) {
      return true;
    }
  
    if (!this.accessProfile?.permissions?.length) {
      return false;
    }
    return this.accessProfile.permissions.includes(permission);
  }

  hasAnyPermission(...permissions: Permission[]): boolean {
    for (const permission of permissions) {
      if (this.hasPermission(permission)) {
        return true;
      }
    }
    return false;
  }

  isLegacyPermissionUser(): boolean {
    return !this.accessProfile?.permissions?.length;
  }

  isPlatformAdmin(): boolean {
    if (this.isAdmin()) {
      return true;
    }
    return !!this.accessProfile?.permissions?.includes(Permission.GLOBAL_ACCESS);
  }

  hasPlatformAdminAccess(): boolean {
    return this.isPlatformAdmin();
  }

  hasPermissionOrLegacy(permission: Permission): boolean {
    if (this.isLegacyPermissionUser()) {
      return true;
    }

    if (this.hasPlatformAdminAccess()) {
      return true;
    }

    return this.hasPermission(permission);
  }

  hasAnyPermissionOrLegacy(...permissions: Permission[]): boolean {
    if (this.isLegacyPermissionUser()) {
      return true;
    }
    for (const permission of permissions) {
      if (permission === Permission.GLOBAL_ACCESS && this.hasPlatformAdminAccess()) {
        return true;
      }

      if (this.hasPermissionOrLegacy(permission)) {
        return true;
      }
    }
    return false;
  }

  hasAnyBuyPermission(): boolean {
    return this.hasAnyPermission(...BUY_PERMISSIONS);
  }

  hasAnySellPermission(): boolean {
    return this.hasAnyPermission(...SELL_PERMISSIONS);
  }

  hasLegacyBuyRoles(): boolean {
    return this.hasRoles(
      Role.DESK_BUY,
      Role.SELLER,
      Role.SELLER_MANAGER,
      Role.EVALUATOR,
      Role.EVAL_DEALER_MANAGER,
      Role.SUPER_EVALUATOR,
      Role.OEM_DEALER_MANAGER,
    );
  }

  canViewPricingUserFilter(): boolean {
    return this.hasAnyPermission(Permission.PRICE_EVALUATION)
      || this.hasRoles(Role.ADMIN, Role.DESK_BUY, Role.OEM_DEALER_MANAGER);
  }

  hasLegacySellRoles(): boolean {
    return this.hasRoles(Role.REGISTERER, Role.DESK_SELL, Role.OEM_DEALER_MANAGER, Role.LOCATION_MANAGER);
  }

  canAccessSystemAdminMenu(): boolean {
    return this.canAccessPlatformAdminMenu();
  }

  canAccessPlatformAdminMenu(): boolean {
    return this.hasAnyPermission(...SYSTEM_ADMIN_PERMISSIONS) || this.isAdmin();
  }

  canAccessOemDealerAdminMenu(): boolean {
    return this.hasPermissionOemDealerManager();
  }

  canAccessAdminMenu(): boolean {
    return this.canAccessPlatformAdminMenu() || this.canAccessOemDealerAdminMenu();
  }

  canViewContextualOemDealerAdmin(): boolean {
    return this.canAccessOemDealerAdminMenu() && !!this.resolveContextOemDealerId();
  }

  canViewDealersPlatform(): boolean {
    return this.hasPermissionOrLegacy(Permission.VIEW_DEALERS);
  }

  canAccessOemDealerList(): boolean {
    return this.hasPermissionOrLegacy(Permission.VIEW_OEMDEALERS)
      || this.hasPermissionOrLegacy(Permission.CREATE_NEW_OEMDEALER);
  }

  canViewOemDealersPlatform(): boolean {
    return this.canAccessOemDealerList();
  }

  canDownloadOemDealerCsv(): boolean {
    return this.hasPermissionOrLegacy(Permission.DOWNLOAD_OEMDEALER_CSV);
  }

  canDownloadDealerCsv(): boolean {
    return this.hasPermissionOrLegacy(Permission.DOWNLOAD_DEALER_CSV);
  }

  canCreateOemDealer(): boolean {
    return this.canManageOemEnvironment();
  }

  canManageOemEnvironment(): boolean {
    return this.hasPermissionOrLegacy(Permission.CREATE_NEW_OEMDEALER);
  }

  canViewBankslipsPlatform(): boolean {
    return this.hasPermissionOrLegacy(Permission.VIEW_BANKSLIPS);
  }

  canViewBankslipsSummary(): boolean {
    if (this.isLegacyPermissionUser()) {
      return this.hasRoles(Role.ADMIN, Role.OEM_DEALER_MANAGER);
    }
    return this.hasPermission(Permission.VIEW_BANKSLIPS_SUMMARY);
  }

  canReissueBankslip(): boolean {
    return this.hasPermissionOrLegacy(Permission.RESSUE_BANKSLIP);
  }

  canDownloadBankslipCsv(): boolean {
    return this.hasPermissionOrLegacy(Permission.DOWNLOAD_BANKSLIP_CSV);
  }

  canViewIntegrationsPlatform(): boolean {
    return this.hasPermissionOrLegacy(Permission.VIEW_INTEGRATIONS)
      || this.canManageSellerIntegrations();
  }

  canManageSellerIntegrations(): boolean {
    return this.hasPermissionOrLegacy(Permission.MANAGE_SELLER_INTEGRATIONS);
  }

  canManageApiKeysPlatform(): boolean {
    return this.hasPermissionOrLegacy(Permission.MANAGE_API_KEYS);
  }

  canManageApiKeys(): boolean {
    return this.canManageApiKeysPlatform();
  }

  canManageFipePlatform(): boolean {
    return this.hasPermissionOrLegacy(Permission.MANAGE_FIPE);
  }

  canManageBannersPlatform(): boolean {
    return this.hasPermissionOrLegacy(Permission.MANAGE_BANNERS);
  }

  canManageHomePlatform(): boolean {
    return this.hasPermissionOrLegacy(Permission.MANAGE_HOME);
  }

  canManageSlugPlatform(): boolean {
    return this.hasPermissionOrLegacy(Permission.MANAGE_SLUG);
  }

  canManageSellerContractsPlatform(): boolean {
    return this.hasPermissionOrLegacy(Permission.MANAGE_SELLER_CONTRACTS);
  }

  canManageSellerPersonalization(): boolean {
    return this.hasPermissionOrLegacy(Permission.MANAGE_SELLER_PERSONALIZATION);
  }

  canManageSellerUnits(): boolean {
    return this.hasPermissionOrLegacy(Permission.MANAGE_EVAL_DEALERS)
      || this.hasPermissionOrLegacy(Permission.CREATE_NEW_OEMDEALER);
  }

  canManageSellerYards(): boolean {
    return this.hasPermissionOrLegacy(Permission.MANAGE_OEM_DEALER_LOCATION)
      || this.hasPermissionOrLegacy(Permission.CREATE_NEW_OEMDEALER);
  }

  canManageSellerUnitsAndYards(): boolean {
    return this.canManageSellerUnits() || this.canManageSellerYards();
  }

  canManageEnvironmentUsers(): boolean {
    return this.hasPermissionOrLegacy(Permission.MANAGE_ENVIRONMENT_USERS);
  }

  canImportMassUsers(): boolean {
    return this.hasPermissionOrLegacy(Permission.IMPORT_MASS_USERS);
  }

  canManageOemDealerAccessProfiles(): boolean {
    return this.hasPermissionOrLegacy(Permission.MANAGE_ACCESS_PROFILES);
  }

  canManagePlatformAccessProfiles(): boolean {
    return this.hasPermissionOrLegacy(Permission.MANAGE_ACCESS_PROFILES);
  }

  hasRoleAvaliador(): boolean {
    return this.hasAnyBuyPermission() || this.hasLegacyBuyRoles() || this.isAdmin();
  }

  hasRoleArremate(): boolean {
    return this.hasRoles(Role.DEALER) || this.isAdmin();
  }

  hasPermissionOemDealerDashboard(): boolean {
    return this.hasRoles(Role.DESK_SELL, Role.OEM_DEALER_MANAGER) || this.isAdmin();
  }

  isAdmin(): boolean {
    return this.hasRole(Role.ADMIN);
  }

  isOemDealerManager(): boolean {
    return this.hasRoles(Role.ADMIN, Role.OEM_DEALER_MANAGER);
  }

  isDealer(): boolean {
    return this.hasRole(Role.DEALER) && this.dealerId !== undefined;
  }

  hasPermissionMenuVehicle(): boolean {
    return this.hasRoles(Role.DEALER);
  }

  hasPermissionMenuVender(): boolean {
    return this.hasAnySellPermission() || this.hasLegacySellRoles() || this.isAdmin();
  }

  getDefaultSellRoute(): string | null {
    if (!this.hasPermissionMenuVender()) {
      return null;
    }

    if (this.hasLegacySellRoles() || this.isAdmin() || this.hasPermission(Permission.VIEW_TRANSFER_VEHICLES)) {
      return '/vender/veiculos';
    }
    if (this.hasPermission(Permission.VIEW_STOCK)) {
      return '/vender/estoque';
    }
    if (this.hasPermission(Permission.VIEW_LEADS_VEHICLES)) {
      return '/vender/leads';
    }
    if (this.hasPermission(Permission.VIEW_DELETED_VEHICLES)) {
      return '/vender/excluidos';
    }
    if (this.hasPermission(Permission.IMPORT_MASS_TRANSFERS)) {
      return '/vender/importar';
    }
    if (this.hasPermission(Permission.VIEW_REPORT_SELL)) {
      return '/vender/relatorios';
    }
    if (this.hasPermission(Permission.VIEW_TRADEIN_DASHBOARD)) {
      return '/dashboard/tradein';
    }

    return null;
  }

  getDefaultOemDealerAdminMenuParam(): 'buy' | 'sell' | 'admin' {
    if (this.hasAnyBuyPermission() || this.hasLegacyBuyRoles()) {
      return 'buy';
    }
    if (this.hasPermissionMenuVender()) {
      return 'sell';
    }
    return 'admin';
  }

  getDefaultOemDealerAdminRoute(): string | null {
    if (!this.hasPermissionOemDealerManager()) {
      return null;
    }

    const oemDealerId = this.resolveContextOemDealerId();
    if (!oemDealerId) {
      return null;
    }

    const params = new URLSearchParams({
      menu: this.getDefaultOemDealerAdminMenuParam(),
      oemDealerId,
    });
    return `/vender/admin?${params.toString()}`;
  }

  getDefaultPlatformAdminRoute(): string | null {
    if (this.hasAnyPermission(Permission.VIEW_DEALERS, Permission.DOWNLOAD_DEALER_CSV)) {
      return '/admin/dealer';
    }
    if (this.hasAnyPermission(
      Permission.VIEW_OEMDEALERS,
      Permission.CREATE_NEW_OEMDEALER,
      Permission.DOWNLOAD_OEMDEALER_CSV,
      Permission.VIEW_INTEGRATIONS,
      Permission.MANAGE_SELLER_INTEGRATIONS,
      Permission.MANAGE_API_KEYS,
      Permission.MANAGE_SELLER_CONTRACTS,
    )) {
      return '/admin/advertisers/list';
    }
    if (this.hasPermission(Permission.VIEW_BANKSLIPS)) {
      return '/admin/boletos';
    }
    if (this.hasAnyPermission(
      Permission.VIEW_EVALUATION_DASHBOARD,
      Permission.DASHBOARD_MAIN_PAGE,
    )) {
      return '/admin/dashboards';
    }
    if (this.hasPermission(Permission.MANAGE_FIPE)) {
      return '/admin/fipeFutura';
    }
    if (this.hasPermission(Permission.MANAGE_BANNERS)) {
      return '/admin/banner';
    }
    if (this.hasPermission(Permission.MANAGE_HOME)) {
      return '/admin/home-management';
    }
    if (this.hasPermission(Permission.MANAGE_SLUG)) {
      return '/admin/slug-management';
    }
    if (this.hasPermission(Permission.MANAGE_REGIONALS)) {
      return '/admin/regionals';
    }

    return null;
  }

  hasPermissionOemDealerManager(): boolean {
    if (this.isLegacyPermissionUser()) {
      return this.hasRoles(Role.OEM_DEALER_MANAGER)
        || (this.isAdmin() && this.oemDealerGroupSelected !== undefined);
    }
    return this.hasAnyPermission(...OEM_DEALER_ADMIN_PERMISSIONS);
  }

  hasPermissionDeskSell(): boolean {
    return this.hasPermissionOemDealerManager() || this.isAdmin() || this.hasRole(Role.DESK_SELL);
  }

  canAcceptProposalBelowMargin(): boolean {
    return this.hasRoles(
      Role.ADMIN,
      Role.OEM_DEALER_MANAGER,
      Role.DESK_BUY,
      Role.EVAL_DEALER_MANAGER,
      Role.DESK_SELL
    ) || 
    this.hasPermission(Permission.ACCEPT_PROPOSAL_BELOW_MARGIN);
  }

  canGeneratePaymentMethod(): boolean {
    return this.isAdmin()
      || this.hasAnyPermission(Permission.GLOBAL_ACCESS, Permission.GENERATE_PAYMENT_METHOD);
  }

  canViewIntegrationHistoryDetails(): boolean {
    return this.hasRoles(Role.ADMIN, Role.OEM_DEALER_MANAGER)
      || this.hasAnyPermission(Permission.VIEW_INTEGRATION_HISTORY_DETAILS);
  }

  canViewWebhookHistory(): boolean {
    return this.isAdmin() || this.hasAnyPermission(Permission.VIEW_WEBHOOK_HISTORY);
  }

  canViewTransferViewers(): boolean {
    if (this.isLegacyPermissionUser()) {
      return this.hasLegacySellRoles() || this.isAdmin();
    }
    return this.hasPermission(Permission.VIEW_TRANSFER_VIEWERS);
  }

  canViewFastQuoteViewers(): boolean {
    if (this.isLegacyPermissionUser()) {
      return this.hasLegacySellRoles()
        || this.isAdmin()
        || this.hasRoles(Role.SELLER, Role.SELLER_MANAGER, Role.EVAL_DEALER_MANAGER, Role.DESK_BUY);
    }
    return this.hasPermission(Permission.VIEW_FAST_QUOTE_VIEWERS);
  }

  resolveContextOemDealerId(): string | null {
    if (this.oemDealerGroupSelected?.id) {
      return this.oemDealerGroupSelected.id;
    }
    if (this.oemDealerId) {
      return this.oemDealerId;
    }
    if (this.accessProfile?.oemDealerId) {
      return this.accessProfile.oemDealerId;
    }
    if (this.oemDealers?.length === 1) {
      return this.oemDealers[0].id;
    }
    return null;
  }

  hasOemDealerContext(): boolean {
    return !!this.resolveContextOemDealerId() || (this.oemDealers?.length ?? 0) > 0;
  }

  getSecondaryNameDisplay(): string {
    const userInfo = this;
    if (
      userInfo.oemDealerGroupName &&
      userInfo.oemDealers &&
      userInfo.oemDealers.length > 0
    ) {
      return userInfo.oemDealerGroupSelected
        ? userInfo.oemDealerGroupSelected.name
        : "Visão consolidada";
    }

    if (userInfo.oemDealerGroupName) {
      return userInfo.oemDealerGroupName;
    }

    if (userInfo.oemDealerName) {
      return userInfo.oemDealerName;
    }

    if (userInfo.dealerName) {
      return userInfo.dealerName;
    }

    return null;
  }

  get evalDealersIds(): string[] {
    if (this.evalDealers && this.evalDealers.length > 0) {
      return this.evalDealers.map(ev => ev.id);
    } else {
      return [];
    }
  }

  get showListPlates(): boolean {
    return this.oemDealersWithIntegrationReport && this.oemDealersWithIntegrationReport.length > 0 && this.oemDealerGroupSelected && this.oemDealersWithIntegrationReport.includes(this.oemDealerGroupSelected.id);
  }
}


export class LayoutVars {
  primaryColor: string;
  buttonColor: string;
  buttonHoverColor: string;
  logoUrl: string;
  raioXLogoUrl: string;
  evaluationLogoUrl: string;
  offerColor: string;
  loginBgImageUrl: string;
  oemDealerId: string;
  alternativeDomain: string;
  menuItemColor: string;
  menuItemColorHover: string;
  contacts: Contact[];
  name: string;
  favIcon: string;
  appIcon: string | null;
  noNotificationWhatsapp: boolean;
  allowedRegisterType: string[];
  footerLinkUrl: string;
  showSuperBidLogin: boolean;
  logoDestinationUrl: string;
  marketplaceMenuLabel: string;
  noAllowSensitiveData: boolean;
  secondaryColorOragen: string;

  personalizedTermsUrl: string;
  personalizedTermsCTA: string;

  targetBuyers: string;
  invalidTargetBuyerErrorMessage: string;

  allowADLogin: boolean;
  allowOnlyADLogin: boolean;
  scripts: Script[]
  allowPublicationScheduling: boolean;

  federatedLoginConfigs: FederatedLoginConfig[];
  notShowAARRules: boolean;
  allowPublicAccess: boolean;
  footerContacts: any;
  linkAboutUs: any;
  linkContact: any;
  footerLinks: FooterLink[];
  noShowFooterLogo: boolean;
  transactional: boolean;
}

export class Contact {
  type: string;
  label: string;
  contact: string;
}

export enum ContactType {
  WHATSAPP = "WhatsApp",
  PHONE_NUMBER = "Telefone",
  EMAIL = "Email",
}

export enum FooterContactType {
  ADDRESS = "Endereço",
  EMAIL = "Email",
  FACEBOOK = "Facebook",
  INSTAGRAM = "Instagram",
  LINKEDIN = "LinkedIn",
  PHONE_NUMBER = "Telefone",
  WHATSAPP = "WhatsApp",
  X = "X",
}

export interface SessionState {
  isAuthenticated: boolean;
  userInfo: UserInfo;
}

export function createInitialState(): SessionState {
  return {
    isAuthenticated: false,
    userInfo: null
  };
}

function mergeUserInfoState(userInfo: UserInfo, patch: Partial<UserInfo>): UserInfo {
  return Object.assign(new UserInfo(), userInfo, patch);
}

@Injectable({
  providedIn: 'root'
})
@StoreConfig({ name: 'sessionState' })
export class SessionStore extends Store<SessionState> {
  constructor() {
    super(createInitialState());
  }

  updateStatusPlan(status: boolean) {
    this.update(state => {
      if (!state.userInfo) {
        return state;
      }

      return {
        ...state,
        userInfo: mergeUserInfoState(state.userInfo, { hasPlan: status }),
      };
    });
  }

  clearSession(): void {
    this._setState(state => createInitialState());
  }

  updateOemDealersSelected(oemDealerGroupSelected) {
    this.update(state => {
      if (!state.userInfo) {
        return state;
      }

      return {
        ...state,
        userInfo: mergeUserInfoState(state.userInfo, {
          oemDealerGroupSelected
        }),
      };
    });
  }

  updateDealersSelected(dealerGroupSelected: IdName, hasLatePayment) {
    this.update(state => {
      if (!state.userInfo) {
        return state;
      }

      return {
        ...state,
        userInfo: mergeUserInfoState(state.userInfo, {
          dealerGroupSelected,
          hasLatePayment,
          dealerId: dealerGroupSelected.id,
          dealerName: dealerGroupSelected.name,
        }),
      };
    });
  }
}
